module.exports = __webpack_public_path__ + "static/changing-the-face-of-science-menu-thumbnails-400x400-440590714adc6508bebc17cfb91c96e5.jpg";